import React from 'react';
import { MapPinImage } from '../../../../../assets/images';
import { ImageTextLink } from '../../imageTextLink';
import { TextLink } from '../../textLink';
import { ImageAlignment } from '../../../../../models';

interface DirectionsLinkProps {
  caption?: string;
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zipcode: string;
  includeImage?: boolean;
}

const directionsCaption = 'Get Directions';
const googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=';

const getMapsAddress = (
  zipcode: string,
  street1?: string,
  city?: string,
  state?: string
): string => {
  let mapAddress = '';

  if (street1) {
    mapAddress += street1;
  }

  if (city) {
    if (mapAddress.length > 0) {
      mapAddress += '+';
    }

    mapAddress += city;
  }

  if (state) {
    if (mapAddress.length > 0) {
      mapAddress += '+';
    }

    mapAddress += state;
  }

  if (zipcode) {
    if (mapAddress.length > 0) {
      mapAddress += '+';
    }

    mapAddress += zipcode;
  }

  return mapAddress;
};

const DirectionsLink: React.FC<DirectionsLinkProps> = (
  props: DirectionsLinkProps
) => {
  const onLinkClicked = () => {
    window.open(
      `${googleMapsUrl}${encodeURIComponent(
        getMapsAddress(props.zipcode, props.street1, props.city, props.state)
      )}`,
      '_blank'
    );
  };

  return (
    <>
      {props.includeImage === undefined || props.includeImage ? (
        <ImageTextLink
          imageSource={MapPinImage}
          caption={props.caption ?? directionsCaption}
          onClick={onLinkClicked}
          imageAlignment={ImageAlignment.Left}
          allowWrap={false}
        />
      ) : (
        <TextLink
          caption={props.caption ?? directionsCaption}
          onClick={onLinkClicked}
        />
      )}
    </>
  );
};

export default DirectionsLink;
